import React from 'react';
import { NavLink } from 'react-router-dom';

import CardActions from '@material-ui/core/CardActions';

import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import SaveAltIcon from '@material-ui/icons/SaveAlt';

export default function TradePresenterCardLinks(props) {
  let pageLink = '';
  if (props.link != null) {
    pageLink = props.link;
  }
  return (
    <CardActions>
      <Box display='flex' justifyContent='space-between' width={1} px={1}>
        <Box>
          {props.pdf && (
            <IconButton
              href={props.pdf && props.pdf[0].craftercms.path}
              download
            >
              <SaveAltIcon color='secondary' />
            </IconButton>
          )}
        </Box>
        <Box>
          <NavLink to={pageLink}>
            <Button color='secondary' aria-label='view'>
              {props.buttontext}
            </Button>
          </NavLink>
        </Box>
      </Box>
    </CardActions>
  );
}
